/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOfficeListingAllType_requestSearchPortalOfficeListingsAllTypeUseEngine } from '../models/api_portalOfficeListingAllType_requestSearchPortalOfficeListingsAllTypeUseEngine';
import type { api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine } from '../models/api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeListingAllTypeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search All Tupe PortalOfficeListing use rest-schedule-engine
     * 検索エンジンをコールして全ての事業所タイプの掲載情報をミックスして検索する。ステーション掲載情報を最大1000件、医療機関掲載情報を最大1000件の、最大2000件取得する。
     * @returns api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine responseSearchPortalOfficeListingsAllTypeUseEngine
     * @throws ApiError
     */
    public postPortalOfficeListingAllTypeSearchEngine({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListingsAllTypeUseEngine
         */
        body: api_portalOfficeListingAllType_requestSearchPortalOfficeListingsAllTypeUseEngine,
    }): CancelablePromise<api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing_all_type/search_engine',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search All Tupe PortalOfficeListing use rest-schedule-engine for Non-members
     * 非会員用に、検索エンジンをコールして全ての事業所タイプの掲載情報をミックスして検索する。ステーション掲載情報を最大1000件、医療機関掲載情報を最大1000件の、最大2000件取得する。
     * @returns api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine responseSearchPortalOfficeListingsAllTypeUseEngine
     * @throws ApiError
     */
    public postPortalOfficeListingAllTypeSearchEngineForNonMember({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListingsAllTypeUseEngine
         */
        body: api_portalOfficeListingAllType_requestSearchPortalOfficeListingsAllTypeUseEngine,
    }): CancelablePromise<api_portalOfficeListingAllType_responseSearchPortalOfficeListingsAllTypeUseEngine> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing_all_type/search_engine_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
